class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	generateRecommendations(){
		const cartItems = document.getElementById('AjaxCartForm').querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length > 0 ) {
			let cartItem;
			cartItems.forEach((product) => {
				if (product.getAttribute('data-price') != '0') {
					cartItem = product;
				}
			});
			fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${cartItem.dataset.productId}&limit=${this.dataset.limit}`)
				.then(response => response.text())
				.then(text => {
					const innerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-js-cart-recommendations-performed]');
          if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
          	this.innerHTML = innerHTML.innerHTML;
          }
				}).then(()=>{
					cartSliderFormSubmit("#cart-recommendations form.upsell", false)
					cartSliderSelect("#cart-recommendations form.upsell select")
					if (window.swat) window.swat.initializeActionButtons('body')
				})
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);
